import { render, staticRenderFns } from "./Frames.vue?vue&type=template&id=5b3cbf2a&"
import script from "./Frames.vue?vue&type=script&lang=ts&"
export * from "./Frames.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports